/**
 * Created by dmarthak on 26/04/18.
 */
define(function (require, exports, module) {

    'use strict';

    module.exports = function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function transformInput(text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if(transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                ngModelCtrl.$parsers.push(transformInput);
            }
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/directives/only-numbers.js
// module id = 6
// module chunks = 0